<div class="container-scroller">
  <div class="container-fluid page-body-wrapper full-page-wrapper">
    <div class="content-wrapper auth">
      <div class="auth-form desktop">
        <div class="brand-logo">
          <img src="assets/img/OpStoom_logo_30-jaar.svg" alt="Logo" />
        </div>

        <h4 class="title">{{ "forgotPassword.title" | translate }}</h4>
        <h6 class="subtitle fw-light">
          {{ "forgotPassword.instruction" | translate }}
        </h6>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <input
              type="text"
              formControlName="username"
              placeholder="{{ 'forgotPassword.username' | translate }}"
              class="form-control"
            />
          </div>

          <div class="action">
            <action-button
              (actionEvent)="onSubmit($event)"
              label="{{ 'forgotPassword.sendLink' | translate }}"
            >
              <span class="material-icons-outlined">send</span>
              {{ "forgotPassword.sendLink" | translate }}
            </action-button>
          </div>
          <button class="back-button" (click)="logout()">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
          </button>
          <messages
            class="message"
            [form]="form"
            [messagesObserver]="messages"
            [showNonFieldKeys]="TRUE"
            [showFieldName]="TRUE"
            [showFieldKeys]="FALSE"
          ></messages>
        </form>
      </div>
    </div>
  </div>
</div>
